import React from 'react'

import { FloorTabInterface } from '@store/types'

import { floorTabItems } from '@utilities/floor-tab'

interface GalleryTabProps {
  activeTab: string
  onTabChange: (arg: string) => void
}

function GalleryTab({ activeTab, onTabChange }: GalleryTabProps) {
  const tabItems = React.useMemo(
    () => floorTabItems().filter((item) => item.key !== 'floor'),
    []
  )

  return (
    <div className="flex">
      {tabItems.map((tab: FloorTabInterface) => (
        <button
          key={tab.key}
          type="button"
          className={`text-md border border-mainColour first:rounded-l-md last:rounded-r-md ${
            activeTab === tab.key
              ? 'bg-mainColour font-bold text-white underline underline-offset-4'
              : 'bg-white font-medium text-mainColour'
          } px-8 py-2 tracking-widest`}
          onClick={(e) => {
            e.stopPropagation()
            onTabChange(tab.key)
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}

export default GalleryTab
